//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
export default {
    props: ['loc', 'onLocChange'],
    computed: {
        tempAddress() {
            return this.$store.state.orderAddress
        },
        formattedPhone() {
            return this.loc.phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
        },
        openHours() {
            if (this.loc && this.loc.content && this.loc.content.hours) {
                let day = moment().format('ddd').toLowerCase()
                let open = this.loc.content.hours[0][`${day}_open`]
                let close = this.loc.content.hours[0][`${day}_close`]
                if (open == 'closed') {
                    return 'Closed today'
                }
                if (open == close) {
                    return 'Open 24 Hours'
                } else {
                    if (close.match(/00$/)) {
                        return `Open today til ${moment(close, 'H:mm').format('h A')}`
                    } else {
                        return `Open today til ${moment(close, 'H:mm').format('h:mm A')}`
                    }
                }
                console.log(this.loc.content.hours, open, close)
            } else {
                return ''
            }
        },
        allHours() {
            if (this.loc) {
                let days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
                let fullDays = [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                ]
                let day = {
                    start: null,
                    open: null,
                    close: null,
                    text: "",
                }
                let hours = []
                days.map((d, i) => {
                    let open = moment(
                        this.loc.content.hours[0][`${d}_open`],
                        'h:mm'
                    ).format('h:mm A');
                    let openMilitary = moment(
                        this.loc.content.hours[0][`${d}_open`],
                        'h:mm'
                    ).format('HH');

                    let close = moment(
                        this.loc.content.hours[0][`${d}_close`],
                        'h:mm'
                    ).format('h:mm A')
                    let closeMilitary = moment(
                        this.loc.content.hours[0][`${d}_close`],
                        'h:mm'
                    ).format('HH')
                    if (!day.start) {
                        day = {
                            start: d,
                            open: open,
                            openMilitary: openMilitary,
                            close: close,
                            closeMilitary: closeMilitary,
                            text: this.openingHoursText(open, openMilitary, close, closeMilitary, fullDays, i, days),
                        }
                    } else if (day.open != open || day.close != close) {
                        hours.push({
                            days: d == day.start ? d : day.start == days[i - 1] ? day.start : `${day.start} - ${days[i - 1]}`,
                            open: day.open,
                            openMilitary: day.openMilitary,
                            close: day.close,
                            closeMilitary: day.closeMilitary,
                            text: this.openingHoursText(day.open, day.openMilitary, day.close, day.closeMilitary, fullDays, i-1, days),
                        })
                        if (i == 6) {
                            hours.push({
                                days: `${d}`,
                                open: open,
                                openMilitary: openMilitary,
                                close: close,
                                closeMilitary: closeMilitary,
                                text: this.openingHoursText(open, openMilitary, close, closeMilitary, fullDays, i, days),
                            })
                        } else {
                            day = {
                                start: d,
                                open: open,
                                openMilitary: openMilitary,
                                close: close,
                                closeMilitary: closeMilitary,
                                text: this.openingHoursText(open, openMilitary, close, closeMilitary, fullDays, i, days),
                            }
                        }
                    } else if (i == 6) {
                        hours.push({
                            days:
                                day.start == days[i] ? day.start : day.start == days[i] ? day.start : `${day.start} - ${days[i]}`,
                            open: day.open,
                            openMilitary: day.openMilitary,
                            close: day.close,
                            closeMilitary: day.closeMilitary,
                            text: this.openingHoursText(day.open, day.openMilitary, day.close, day.closeMilitary, fullDays, i, days),
                        })
                    }
                })
                return hours
            } else {
                return []
            }
        },
        services1() {
            let services = []
            let mid = Math.ceil(this.loc.content.services.length / 2)
            this.loc.content.services.map((s, i) => {
                if (i < mid) {
                    services.push(s)
                }
            })
            return services
        },
        services2() {
            let services = []
            // console.log('services',)
            let mid = Math.ceil(this.loc.content.services.length / 2)
            this.loc.content.services.map((s, i) => {
                if (i >= mid) {
                    services.push(s)
                }
            })
            return services
        },
        getDirections() {
            return encodeURI(
                // `https://www.google.com/maps/place/${this.loc.content.address}, ${this.loc.content.city}, ${this.loc.content.state} ${this.loc.content.zipcode}`
                this.loc?.content?.google_business_link
            )
        },
        currentLoc() {
            return this.$store.state.location
        },
    },
    data() {
        return {
            menuHeight: 391,
            showInfo: false,
            scrollable: true,
            showTurkeyModal: false
        }
    },
    mounted() {
        // console.log('this.loc:::: ', this.loc)

        if (this.loc.slug === '6813-sand-lake-rd') {// on turkey lake location show modal             
            this.showTurkeyModal = true
        }
        window.addEventListener('resize', this.matchHeight)
        // this.matchHeight()

        // START if url has rwg_token param, set cookie.
        function setCookie(name, value, days) {
            document.cookie = `${name}=${value}; path=/;  max-age=${60 * 60 * 24 * days};`;
        }

        let params = new URL(document.location).searchParams;
        let rwg_token = params.get("rwg_token");
        console.log('rwg_token:::: ', rwg_token)
        if (rwg_token) {
            setCookie('rwg_token', rwg_token, 30)
        }
        // END if url has rwg_token param, set cookie.
    },
    filters: {
        handoffText(v) {
            switch (v) {
                case 'pickup':
                    return 'Pickup'
                    break
                case 'curbside':
                    return 'Curbside'
                    break
                default:
                    return 'Delivery'
            }
        },
    },
    methods: {
        openingHoursText(open, openMilitary, close, closeMilitary, days, currentDay, shortDays) {

            if (open == 'closed') {
                return 'Closed'
            }
            if (open == close) {
                return 'Open 24 Hours'
            } else {
                // console.log('open::::: ', open)
                // console.log('close::: ', close)
                // console.log('closeMilitary::::: ', closeMilitary) 
                if(Number(openMilitary) == 0 && Number(closeMilitary) < 5) {
                    console.log('open:::: ', open)
                    // return 'Open 24 Hours, Closes '+ Number(closeMilitary) + 'AM '+ shortDays[currentDay+1].toUpperCase();
                    return open + ' - ' + close + ' ' + shortDays[currentDay+1].toUpperCase();
                }

                if(Number(openMilitary) != 0 && (Number(closeMilitary) < 5 && Number(closeMilitary) != 0)) {
                    // return open +" - "+ closeMilitary + " (Following Day)";
                    return open +" - "+ close //+ " (Following Day)";
                }

                if(Number(openMilitary) != 0 && Number(closeMilitary) == 0) {
                    
                    // return open +" - Midnight";
                    return open + " - " + close;
                }

                return open +" - "+ close;
            }
        },
        matchHeight() {
            setTimeout(
                function () {
                    if (this.$refs.menuHeader) {
                        let height = this.$refs.menuHeader.clientHeight
                        this.menuHeight = height
                    }
                }.bind(this),
                100
            )
        },
        async startOrder(s) {
            this.$store.commit('setLoading', true)
            const location = await this.$api.getLocation(this.loc.content.store_num)
            this.$store.commit('setLocation', location)
            const menu = await this.$api.getMenu(this.loc.content.menu_id)
            this.$store.commit('setLoading', false)
            if (menu) {
                this.$store.commit('setActiveMenu', menu)
                this.$store.commit('setActiveOrder', null)

                if (s) {
                    let order = await this.$api.createOrder(this.loc.content.menu_id)//.then((order) => { <-- this doesn't return a promise
                    const customOrder = order
                    customOrder.handoff = s
                    this.$store.commit('setActiveOrder', customOrder)
                    this.$router.push(`/order/`)
                    // })
                } else {
                    this.$router.push(`/menu/`)
                }
            } else {
                // this.$store.commit('setActiveErrors', ['Connection issue. Please try again'])
            }
        },
        async setDefaultMenu() {
            const canadianStores = ['4800-bender-hill-ave', '1097-kingston-road', '1130-st-laurent-blvd', '600-dixon-rd', '1401-paris-street']

            if (canadianStores.includes(this.loc.slug)) {
                
                switch (this.loc.slug) {
                    case '4800-bender-hill-ave':
                        window.open('https://a.storyblok.com/f/99717/x/c61df85296/1124_main_cdiner-pdf.pdf', '_blank').focus();
                        break;
                    case '1097-kingston-road':
                        window.open('https://a.storyblok.com/f/99717/x/7969996b62/1124_main_pn.pdf', '_blank').focus();
                        break;
                    case '1130-st-laurent-blvd':
                        window.open('https://a.storyblok.com/f/99717/x/99bdef1784/0724_main_hmptn.pdf', '_blank').focus();
                        break;
                    case '600-dixon-rd':
                        window.open('https://a.storyblok.com/f/99717/x/e80de9286c/0724_main_west_t.pdf', '_blank').focus();
                        break;
                    case '1401-paris-street':
                        window.open('https://a.storyblok.com/f/99717/x/6b49a5459d/1124_main_west_sb.pdf', '_blank').focus();
                        break;
                    default:
                        break;
                }
            } else {
                this.$store.commit('setLoading', true)
                const location = await this.$api.getLocation(this.loc.content.store_num)
                this.$store.commit('setLocation', location)
                let menu = await this.$api.getMenu(process.env.DEFAULT_MENU)
                if (menu) {
                    this.$store.commit('setActiveMenu', menu)
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setActiveOrder', null)
                    this.$router.push('/menu')
                } else {
                    this.$store.commit('setLoading', true)
                }
            }
            // this.$store.commit('setLoading', true)
            // const location = await this.$api.getLocation(this.loc.content.store_num)
            // this.$store.commit('setLocation', location)
            // let menu = await this.$api.getMenu(process.env.DEFAULT_MENU)
            // if (menu) {
            //     this.$store.commit('setActiveMenu', menu)
            //     this.$store.commit('setLoading', false)
            //     this.$store.commit('setActiveOrder', null)
            //     this.$router.push('/menu')
            // } else {
            //     this.$store.commit('setLoading', true)
            // }
        }
    },
}
